import { render, staticRenderFns } from "./GlobalBodyClassWatcher.vue?vue&type=template&id=ae7cf82a&scoped=true&"
import script from "./GlobalBodyClassWatcher.vue?vue&type=script&lang=js&"
export * from "./GlobalBodyClassWatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7cf82a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae7cf82a')) {
      api.createRecord('ae7cf82a', component.options)
    } else {
      api.reload('ae7cf82a', component.options)
    }
    module.hot.accept("./GlobalBodyClassWatcher.vue?vue&type=template&id=ae7cf82a&scoped=true&", function () {
      api.rerender('ae7cf82a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/GlobalBodyClassWatcher.vue"
export default component.exports